import { createStore } from 'vuex'

export default createStore({
  state: {
    token: null,
    userInfo: null
  },
  getters: {
    getToken: state => state.token,
    getUserInfo: state => state.userInfo
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    }
  },
  actions: {
    updateToken({ commit }, token) {
      commit('setToken', token);
    },
    updateUserInfo({ commit }, userInfo) {
      commit('setUserInfo', userInfo);
    }
  },
  modules: {
  }
})
